// extracted by css-extract-rspack-plugin
export default {"SnippetForm":"EYBb4","FormSnippetTextArea":"FgWOT"};